exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".style-toolbar-checkbox-wrapper-2N7VL{color:#000;font-size:12px;line-height:20px;cursor:default}", ""]);

// Exports
exports.locals = {
	"toolbar-checkbox-wrapper": "style-toolbar-checkbox-wrapper-2N7VL"
};